/**
 * Numero WhatsApp del lido (parametro 1052, modificabile dal gestionale) ridotto alle sole cifre con il
 * prefisso internazionale, come lo vuole wa.me; '' se non e' valido (il pulsante non compare).
 * Il 39 si aggiunge solo a un cellulare italiano scritto senza prefisso (9 o 10 cifre che iniziano con 3: i
 * numeri vecchi ne hanno 9): con "+" o "00" il prefisso c'e' gia' (+354 123 4567 resta islandese).
 * Nessun prefisso internazionale inizia con 0.
 * Copia identica in sunset-gestionale-git/src/app/servizi-lido/numero-whatsapp.ts: cambiarle insieme.
 */
export function normalizzaNumeroWhatsapp(valore: string | null | undefined): string {
  let cifre = (valore ?? '').replace(/[\s.\-\/()]/g, '');
  let prefissoEsplicito = false;
  if (cifre.startsWith('+')) {
    cifre = cifre.slice(1);
    prefissoEsplicito = true;
  } else if (cifre.startsWith('00')) {
    cifre = cifre.slice(2);
    prefissoEsplicito = true;
  }
  if (!prefissoEsplicito && /^3\d{8,9}$/.test(cifre)) {
    cifre = '39' + cifre;
  }
  return /^[1-9]\d{7,14}$/.test(cifre) ? cifre : '';
}

export function linkWhatsapp(numero: string, testo: string): string {
  const link = `https://wa.me/${numero}`;
  return testo ? `${link}?text=${encodeURIComponent(testo)}` : link;
}
